import { styled } from '@mui/material/styles';

type StyledContentLayoutProps = {
  /** Use full readable width on desktop (e.g. pricing carousels). Default is fixed 768px from `md`. */
  wide?: boolean;
};

const StyledContentLayout = styled('div', {
  shouldForwardProp: prop => prop !== 'wide',
})<StyledContentLayoutProps>`
  flex-grow: 1;
  padding: 1.5rem 2rem;

  ${({ theme }) => theme.breakpoints.up('md')} {
    width: ${({ wide }) => (wide ? 'min(100%, 1200px)' : '768px')};
    margin: 0 auto;
  }
`;

export default StyledContentLayout;
